<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-clip-rotate-multiple"
    [fullScreen]="true">
    <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>
<p-toast position="top-right"></p-toast>

<div class="p-g add-member-res">

    <div class="feeDetailsHeader">
        <div class="feeDetailsHeaderField">
            <p class="memberTagText">
                {{setLabel("serialNumberLabel")}}
            </p>
            <p>{{asset.serialNumber}}</p>
        </div>
        <div class="feeDetailsHeaderField">
            <p class="memberTagText">
                {{setLabel("nameLabel")}}
            </p>
            <p>{{asset.name}}</p>
        </div>
    </div>
    <div class="p-g-12">
        <input type="button" id="save"
            style="width: 147px !important; border-radius: 5px; margin-top: 18px;"
             (click)="openMaintenanceDialog()"
            class="p-button p-widget p-state-default p-corner-all"
            [value]='setLabel("createMaintenanceValueLabel")' />
        &nbsp;&nbsp;
    </div>

    <div class="p-g-12 mobile-padding-0 add-member-res-tabs">
        <p-tabView [activeIndex]="index" (onChange)="handleChange($event)">
            <p-tabPanel [header]='setLabel("detailsHeaderLabel")'>
                <div class="card card-w-title mobile-padding-0 add-member-res-tab-Details">

                    <!-- Asset Profile Image Upload -->
                    <div class="profileImgContainer">
                        <div class="p-g-3 p-md-4 imgstyle">
                            <img
                            style="width: 200px; height: 200px"
                            [src]="
                                uploadProfile
                                    ? uploadProfile
                                    : asset?.profile
                                        ? config.Server + config.assetImagePath + 'thumbs/' + asset.profile
                                        : 'assets/layout/images/2.png'
                            "
                            onerror="this.src = 'assets/layout/images/2.png'"
                            alt="Asset Profile Picture"
                        />

                        </div>
                        <div class="userDetailToolBar">
                            <h3 class="first">{{setLabel("assetPictureLabel")}} </h3>
                            <button (click)="captureImageDialogShow('Cam')" style="height: 2rem;width: 6rem;">
                                <span class="button p-button-text p-c">
                                    <i class="fa fa-camera" aria-hidden="true"></i>
                                    &nbsp;{{setLabel("captureLabel")}}
                                </span>
                            </button>
                            <button (click)="captureImageDialogShow('Upload')" style="height: 2rem;width: 6rem;">
                                <span class="button p-button-text p-c">
                                    <i class="fa fa-upload" aria-hidden="true"></i>
                                    &nbsp;{{setLabel("uploadLabel")}}
                                </span>
                            </button>
                            <button (click)="removeProfileImage()" class="removePhoto" style="height: 2rem;width: 6rem;">
                                <span class="button p-button-text p-c">
                                    <i class="fa fa-times"></i>
                                    &nbsp;{{setLabel("removeLabel")}}
                                </span>
                            </button>
                        </div>
                    </div>


                    <!-- Asset Input Form -->
                    <form #assetForm="ngForm">
                        <div class="p-g-12 single-signup-detail-1-res">
                            <div class="p-g-6" style="text-align: left">
                                <div class="p-g p-fluid">
                                    <!-- Name -->
                                    <h3 class="first">
                                        {{setLabel("assetNameLabel")}}
                                        <span style="color: red">*</span>
                                    </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                                            <input maxlength="100" autocomplete="off" id="name" required name="name" pattern="[A-Za-z ]+"
                                            [ngClass]="
                                            name.invalid &&
                                            (name.dirty ||
                                                name.touched)
                                                ? 'errorInput'
                                                : ''
                                        "
                                            type="text" [(ngModel)]="asset.name"
                                            #name="ngModel"  [placeholder]='setLabel("enterAssetNamePlaceholderLabel")' />
                                        </div>
                                        <div *ngIf="
                                        name.invalid &&
                                        (name.dirty || name.touched)
                                    ">
                                        <div *ngIf="name.errors.required" class="errorShow">
                                            {{setLabel("pleaseEnterNameLabel")}}
                                        </div>
                                        <div *ngIf="name.errors.pattern" class="errorShow">
                                            {{setLabel("pleaseEnterCorrectNameLabel")}}
                                        </div>
                                    </div>
                                    </div>

                                    <!-- Category -->
                                    <h3 class="first">
                                        {{setLabel("categoryLabel")}}
                                        <span style="color: red">*</span>
                                    </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon">
                                            <i class="fa fa-user" aria-hidden="true"></i>
                                        </span>
                                        <p-dropdown
                                            [options]="categories"
                                            [(ngModel)]="asset.category"
                                            [placeholder]='setLabel("selectCategoryPlaceholderLabel")'
                                            name="category"
                                            id="category"
                                            required
                                            #categoryDropdown="ngModel"
                                            [style]="{ width: '100%' }"
                                            [ngClass]="categoryDropdown.invalid && (categoryDropdown.dirty || categoryDropdown.touched) ? 'errorInput' : ''"
                                        >
                                        </p-dropdown>
                                        </div>
                                        <!-- Validation messages -->
                                        <div *ngIf="categoryDropdown.invalid && (categoryDropdown.dirty || categoryDropdown.touched)">
                                        <div *ngIf="categoryDropdown.errors?.required" class="errorShow">
                                            {{setLabel("selectCategoryLabel")}}
                                        </div>
                                        </div>
                                    </div>

                                    <!-- Purchase Date -->
                                    <h3 class="first">{{setLabel("purchaseDateLabel")}} </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                            <p-calendar [yearNavigator]="true" autofocus="true" inline="true"
                                                yearRange="1950:2040" [monthNavigator]="true"
                                                [(ngModel)]="asset.purchaseDate" id="purchaseDate"
                                               [placeholder]='setLabel("purchaseDatePlaceholderLabel")' name="purchaseDate" [inline]="false"
                                                dateFormat="dd/mm/yy" [showIcon]="true">
                                            </p-calendar>
                                        </div>
                                    </div>

                                    <!-- Status (Radio Buttons) -->
                                    <h3 class="first">{{setLabel("statusLabel")}} </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                            <div class="p-g-6">
                                                <p-radioButton name="status" [value]='setLabel("activeValueLabel")' [(ngModel)]="asset.status"
                                                    inputId="statusActive" [label]='setLabel("activeValueLabel")'
                                                    [ngClass]="asset.status === 'Active' ? 'radioBtnHighlite' : ''">
                                                </p-radioButton>
                                            </div>
                                            <div class="p-g-6">
                                                <p-radioButton name="status" [value]='setLabel("underRepairValueLabel")'
                                                    [(ngModel)]="asset.status" inputId="statusInactive"
                                                    [label]='setLabel("underRepairValueLabel")'
                                                    [ngClass]="asset.status === 'UnderRepair' ? 'radioBtnHighlite' : ''">
                                                </p-radioButton>
                                            </div>
                                            <div class="p-g-6">
                                                <p-radioButton name="status" [value]='setLabel("inactiveValueLabel")' [(ngModel)]="asset.status"
                                                    inputId="statusInactive" [label]='setLabel("inactiveValueLabel")'
                                                    [ngClass]="asset.status === 'Inactive' ? 'radioBtnHighlite' : ''">
                                                </p-radioButton>
                                            </div>
                                        </div>
                                    </div>

                                </div> <!-- LEFT DIV -->
                            </div>

                            <div class="p-g-6" style="text-align: left">
                                <div class="p-g p-fluid">

                                    <!-- Cost -->
                                    <h3 class="first">{{setLabel("costLabel")}} </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                            <input type="number" id="cost" name="cost" [(ngModel)]="asset.cost"
                                               [placeholder]='setLabel("enterAssetCostPlaceholder")' />
                                        </div>
                                    </div>

                                    <!-- Serial Number -->

                                    <h3 class="first">{{setLabel("serialNumberLabel")}} </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                            <input type="text" id="serialNumber" name="serialNumber"
                                                [(ngModel)]="asset.serialNumber" [placeholder]='setLabel("enterSerialNumberPlaceholder")' />
                                        </div>
                                    </div>

                                    <!-- Description -->
                                    <h3 class="first">{{setLabel("discriptionLabel")}} </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                            <textarea id="description" name="description"
                                                [(ngModel)]="asset.description"
                                                [placeholder]='setLabel("enterAssetDescriptionPlaceholder")'></textarea>
                                        </div>
                                    </div>

                                    <!-- Warranty Expiry Date -->
                                    <h3 class="first">{{setLabel("warrantyExpiryLabel")}} </h3>
                                    <div class="p-g-12">
                                        <div class="p-inputgroup">
                                            <p-calendar [yearNavigator]="true" autofocus="true" yearRange="1950:2040"
                                                [monthNavigator]="true" [(ngModel)]="asset.warrantyExpiry"
                                                id="expiryDate" [placeholder]='setLabel("warrantExpiryDatePlaceholder")' name="expiryDate"
                                                dateFormat="dd/mm/yy" [showIcon]="true">
                                            </p-calendar>
                                        </div>
                                    </div>

                                    <!-- Form Buttons -->
                                    <div class="p-g-12">
                                        <input type="button" id="save"
                                            style="width: 147px !important; border-radius: 5px"
                                            (click)="validateAssetUpdate(assetForm)" [disabled]=""
                                            class="p-button p-widget p-state-default p-corner-all" [value]='setLabel("updateValueLabel")' />
                                        &nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </p-tabPanel>

        <p-tabPanel [header]='setLabel("maintenanceHeaderLabel")'>

      <p-table #dt [value]="asset.maintenanceLogs" dataKey="id" styleClass="p-table-customers activity-log-table " [rowHover]="true"
        [rows]="100" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
        currentPageReportTemplate="There are {{asset.maintenanceLogs?.length}} records" [filterDelay]="0"
        [globalFilterFields]="['name','country.name','representative.name','status']" class="p-table-tecfolk-fix">

        <ng-template pTemplate="caption">
          <div class="reportMainFilter">


            <div class="reportMainFields">

              <!-- <div class="filterFields">
                <span class="fieldTitle">From</span>
                <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                  [(ngModel)]="from" placeholder='from' [inputStyle]="{'color':'#ffffff'}" name="joinDate"
                  [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getActivityLogs()">
                </p-calendar>
              </div>
              <div class="filterFields">
                <span class="fieldTitle">To</span>
                <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                  [(ngModel)]="to" placeholder='to' [inputStyle]="{'color':'#ffffff'}" name="joinDate"
                  [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getActivityLogs()">
                </p-calendar>
              </div>
              <div class="reportMainBtn">
                <span  pTooltip='Clear Search' tooltipPosition="top" class="iconClear" [disabled]="loading" (click)="resetFilter()"> <i
                    class="pi pi-times"></i></span>
              </div> -->
            <button style="background: #008cba;color: white"
                class="p-button p-widget p-state-default p-corner-all">
                <span class="p-button-text p-c" (click)="printAllInvoice()"><i class="fa fa-print"
                aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("printAllBtnLabel")}}</span></button>&nbsp;&nbsp;
            </div>
            <div class="reportMainBtn">
              <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop" [disabled]="loading" (click)="resetFilter()">
                <i class="pi pi-times"></i></span>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="text-align: left;">{{setLabel("maintenanceDateLabel")}} </th>
          <th style="text-align: left;">{{setLabel("reasonMaintenanceLabel")}}</th>
          <th style="text-align: left;">{{setLabel("costLabel")}}</th>
          <th style="text-align: left;">{{setLabel("createdDateLabel")}}</th>
          <th style="text-align: left;">{{setLabel("notesLabel")}}</th>
          <th style="text-align: left;">{{setLabel("statusLabel")}}</th>
          <th style="text-align: left;">{{setLabel("actionLabel")}}</th>
        </tr>

      </ng-template>
      <ng-template pTemplate="body" let-requestor>
        <tr class="p-selectable-row ">
            <td style="text-align: left;">
                <span>
                  <!-- Check if lastMaintenanceDate exists -->
                  <ng-container *ngIf="requestor?.lastMaintenanceDate; else showStatus">
                    {{ requestor.lastMaintenanceDate | date: 'EEE MMM dd yyyy HH:mm:ss' }}
                  </ng-container>
                  <!-- Display status if lastMaintenanceDate is not present -->
                  <ng-template #showStatus>
                    {{ requestor.status }}
                  </ng-template>
                </span>
              </td>
          <td style="text-align: left;">
            <span>{{ requestor?.maintenanceReason }}
            </span>
          </td>
          <td style="text-align: left;">
            <span class="p-column-title">{{ requestor.cost | currency: 'PKR' }}</span>
          </td>
          <td style="text-align: left;">
            <span class="p-column-title">{{requestor.createdDate | date: 'EEE MMM dd yyyy HH:mm:ss' }}</span>
          </td>
          <td style="text-align: left;">
            <span class="p-column-title">{{requestor.notes}}</span>
          </td>
          <td style="text-align: left;">
            <span class="p-column-title">{{requestor.status}}</span>
          </td>
        <td style="text-align: left;">
            <!-- Conditionally show the "Mark as Complete" button -->
            <button *ngIf="requestor.status === 'Pending' || requestor.status === 'Scheduled'"
                    class="p-button p-button-success"
                    (click)="openCompleteDialog(requestor._id)">
            {{setLabel("markCompleteLabel")}}
            </button>

          </td>

        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" style="text-align:left">{{setLabel("noHistoryFoundLabel")}}</td>
        </tr>
      </ng-template>
    </p-table>
            </p-tabPanel>

            <p-tabPanel [header]='setLabel("maintenanceDetailsHeaderLabel")'>
                <div class="card card-w-title">
                    <div class="p-g-12 single-signup-detail-1-res">
                        <div class="p-g-6" style="text-align: left">
                            <div class="p-g p-fluid">

                                <!-- Last Maintenance Date -->
                                <h3 class="first">{{setLabel("lastMaintenanceDateLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <p-calendar [yearNavigator]="true" [monthNavigator]="true" yearRange="1950:2040"
                                            [(ngModel)]="maintenanceLogs.lastMaintenanceDate"
                                           [placeholder]='setLabel("lastMaintenanceDatePlaceholderLabel")' dateFormat="dd/mm/yy" [showIcon]="true"
                                            name="lastMaintenanceDate"></p-calendar>
                                    </div>
                                </div>

                                <!-- Status -->
                                <h3 class="first">{{setLabel("statusLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon">
                                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                                        </span>
                                        <input type="text" [(ngModel)]="maintenanceLogs.status" [placeholder]='setLabel("statusPlaceholderLabel")'
                                            [style]="{ width: '100%' }" name="status" readonly />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="p-g-6" style="text-align: left">
                            <div class="p-g p-fluid">

                                <!-- Next Maintenance Date -->
                                <h3 class="first">{{setLabel("expectedMaintenanceDateLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <p-calendar [yearNavigator]="true" [monthNavigator]="true" yearRange="1950:2040"
                                            [(ngModel)]="maintenanceLogs.nextMaintenanceDate"
                                            [placeholder]='setLabel("nextMaintenanceDatePlaceholderLabel")' dateFormat="dd/mm/yy" [showIcon]="true"
                                            name="nextMaintenanceDate"></p-calendar>
                                    </div>
                                </div>

                                <!-- Maintenance Cost -->
                                <h3 class="first">{{setLabel("lastMaintenanceCostLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon">
                                            <i class="fa fa-money" aria-hidden="true"></i>
                                        </span>
                                        <input type="number" [(ngModel)]="maintenanceLogs.cost"
                                            [placeholder]='setLabel("enterMaintenanceCostPlaceholderLabel")' name="cost" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>

            <div *ngIf="dialogVisibility" class="tecfolkProfileDialogFix">
                <p-dialog [header]='setLabel("assetProfilePictureHeaderLabel")' [(visible)]="dialogVisibility"
                    class="app-add-profile-image-tecfolk-fix">
                    <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
                        (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
                </p-dialog>
                <!-- popupType : Upload | Cam -->
            </div>
        </p-tabView>

        <!-- Dialog for Creating Maintenance -->
        <p-dialog [(visible)]="displayMaintenaceDialog" modal="true" [header]='setLabel("createMaintenanceSlotHeaderLabel")' [style]="{width: '800px'}">
            <form #maintenanceForm="ngForm">
                <div class="p-g-12 single-signup-detail-1-res">
                    <div class="p-g-6" style="text-align: left">
                        <div class="p-g p-fluid">

                            <h3>{{setLabel("reasonMaintenanceLabel")}}</h3>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <p-dropdown
                                        [options]="[{label: 'Scheduled', value: 'Scheduled'}, {label: 'Damage', value: 'Damage'}]"
                                        [(ngModel)]="createMaintenanceLogs.maintenanceReason"
                                        [placeholder]='setLabel("selectReasonPlaceholder")' name="maintenanceReason"></p-dropdown>
                                </div>
                            </div>

                            <h3 class="first">{{setLabel("expectedMaintenanceDateLabel")}}</h3>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <p-calendar [yearNavigator]="true" [monthNavigator]="true" yearRange="1950:2040"
                                        appendTo="body" [(ngModel)]="createMaintenanceLogs.nextMaintenanceDate"
                                        [placeholder]='setLabel("nextMaintenanceDatePlaceholder")' dateFormat="dd/mm/yy" [showIcon]="true"
                                        name="nextMaintenanceDate"></p-calendar>
                                </div>
                            </div>

                            <!-- Maintained By -->
                            <h3 class="first">{{setLabel("maintainedByLabel")}}</h3>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon">
                                        <i class="fa fa-user" aria-hidden="true"></i>
                                    </span>
                                    <input type="text" [(ngModel)]="createMaintenanceLogs.maintainedBy"
                                        [placeholder]='setLabel("enterMaintainedByPlaceholderLAbel")' name="maintainedBy" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-g-6" style="text-align: left">
                        <div class="p-g p-fluid">

                            <!-- Notes -->
                            <h3 class="first">{{setLabel("notesLabel")}}</h3>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <textarea [(ngModel)]="createMaintenanceLogs.notes" [placeholder]='setLabel("enterNotesPlaceholderLAbel")'
                                        name="notes"></textarea>
                                </div>
                            </div>

                            <!-- Maintenance Cost -->
                            <h3 class="first">{{setLabel("expectedMaintenanceCostLabel")}}</h3>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon">
                                        <i class="fa fa-money" aria-hidden="true"></i>
                                    </span>
                                    <input type="number" [(ngModel)]="createMaintenanceLogs.cost"
                                        [placeholder]='setLabel("enterMaintenanceCostPlaceholderLabel")' name="cost" />
                                </div>
                            </div>

                            <div class="p-g-12">
                                <input type="button" id="save"
                                    style="width: 147px !important; border-radius: 5px; margin-top: 18px; margin-left: 50px"
                                    (click)="updateMaintenance(maintenanceForm)" [disabled]=""
                                    class="p-button p-widget p-state-default p-corner-all" [value]='setLabel("saveValueLabel")' />
                                &nbsp;&nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <p-footer>
                <div class="button-container">
                    <!-- <button type="button" pButton label="Save" icon="pi pi-check" (click)="updateMaintenance(maintenanceForm)" class="p-button-success" style="margin-right: auto;"></button> -->
                    <button type="button" pButton [label]='setLabel("cancelLabel")' icon="pi pi-times" (click)="closeMaintenanceDialog()" class="p-button-secondary" style="margin-left: auto;"></button>
                </div>
            </p-footer>
        </p-dialog>
        <!-- Dialog for Mark as Complete -->
        <p-dialog [(visible)]="displayCompleteDialog" modal="true" [header]='setLabel("completeMaintenanceHeaderLabel")' [style]="{width: '400px'}">
            <div class="p-fluid form-layout">
                <div class="p-field">
                    <label for="maintenanceDate">{{setLabel("maintenanceDateLabel")}}</label>
                    <input id="maintenanceDate" type="text" pInputText [value]="currentDate | date:'dd/MM/yyyy'" readonly />
                </div>
                <div class="p-field">
                    <label for="description">{{setLabel("descriptionLabel")}}</label>
                    <input id="description" type="text" pInputText [(ngModel)]="maintenanceLogs.description" [placeholder]='setLabel("enterdescriptionPlaceholderLabel")' />
                </div>
                <div class="p-field">
                    <label for="cost">{{setLabel("costLabel")}}</label>
                    <input id="cost" type="number" pInputText [(ngModel)]="maintenanceLogs.cost" [placeholder]='setLabel("entercostPlaceholderLabel")' />
                </div>
            </div>
            <p-footer>
                <div class="button-container">
                    <button type="button" pButton [label]='setLabel("saveLabel")' icon="pi pi-check" (click)="markAsComplete()" class="p-button-success" style="margin-right: auto;"></button>
                    <button type="button" pButton [label]='setLabel("cancelLabel")' icon="pi pi-times" (click)="displayCompleteDialog = false" class="p-button-secondary" style="margin-left: auto;"></button>
                </div>
            </p-footer>
        </p-dialog>
<div id="allInvoice" #allInvoice style="display: none;">
    <div class="invoice-box">

        <table>
            <tbody>
                <td style="vertical-align: middle;padding: 0px;">
                    <div *ngIf="branch.reportPrintData.bannerImage.length === 1">
                        <img [src]=" (branch.reportPrintData.bannerImage[0].image  ? config.Server + 'assets/layout/images/companies/' + branch.reportPrintData.bannerImage[0].image  : 'assets/layout/images/logoCompany.png')"
                            onerror="this.src=(branch.reportPrintData.bannerImage[0].image ? config.Server + 'assets/layout/images/companies/' + branch.reportPrintData.bannerImage[0].image  : 'assets/layout/images/logoCompany.png')"
                            alt="Company Logo" style="width: 80%;">
                    </div>
                    <div style="display: flex;" *ngIf="branch.reportPrintData.bannerImage.length > 1">
                        <div *ngFor="let banner of branch.reportPrintData.bannerImage">
                            <img [src]=" (banner.image? config.Server + 'assets/layout/images/companies/' + banner.image  : 'assets/layout/images/logoCompany.png')"
                                onerror="this.src=(banner.image? config.Server + 'assets/layout/images/companies/' + banner.image  : 'assets/layout/images/logoCompany.png')"
                                alt="Company Logo" style="width: 80%;">
                        </div>
                    </div>
                </td>
                    <div style="display: flex; justify-content: space-around; width: 125%;">

                        <td style="display: flex;flex-direction: column;align-items: flex-start;justify-content: space-evenly;height:7rem;">
                            <div style="text-align: justify;">{{branch.reportPrintData.name}}</div>
                            <div style="text-align: justify;">{{branch.reportPrintData.address}}</div>
                            <div style="text-align: justify;" *ngIf="branch.reportPrintData.contact.length === 1">
                                {{setLabel("phoneNo:Label")}} {{branch.reportPrintData.contact[0].contactNumber}}
                            </div>
                            <div *ngIf="branch.reportPrintData.contact.length > 1">
                                <div style="text-align: justify;" *ngFor="let contacts of branch.reportPrintData.contact">
                                    {{setLabel("phoneNo:Label")}} {{ contacts.contactNumber }}
                                </div>
                            </div>

                        </td>
                    </div>

            </tbody>
        </table>

        <table cellpadding="0" cellspacing="0">

            <tr class="information">
                <td colspan="4">
                    <table>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <table style="
                                    width: 100%;
                                    border-collapse: collapse;
                                    font-size: 12px;
                                    margin-top: 10px;
                                    border: 1px solid black;
                                ">
                <thead>
                    <tr>
                        <th style="text-align: center; padding: 8px; border: 1px solid black;">{{setLabel("nameLabel")}}</th>
                        <th style="text-align: center; padding: 8px; border: 1px solid black;">{{setLabel("serialNumberLabel")}}</th>
                        <th style="text-align: center; padding: 8px; border: 1px solid black;">{{setLabel("costLabel")}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="text-align: center; padding: 8px; border: 1px solid black;">{{ asset.name }}</td>
                        <td style="text-align: center; padding: 8px; border: 1px solid black;">{{ asset.serialNumber }}</td>
                        <td style="text-align: center; padding: 8px; border: 1px solid black;">{{ asset.cost }}</td>
                    </tr>
                </tbody>
            </table>
            <tr>
                <table style="border-spacing: inherit;" class="tablerpt">
                    <tbody>
                        <tr style="background-color: black;color: white;text-align: center;">
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("maintenanceDateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("reasonMaintenanceLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("costLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("createdDateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("statusLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("nextMaintenanceDateLabel")}}</td>

                        </tr>
                        <tr class="item" *ngFor="let item of reports.maintenanceLogs">
                            <td
                                style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.lastMaintenanceDate | date: 'EEE MMM dd yyyy HH:mm:ss'}}
                            </td>
                            <td
                                style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.maintenanceReason}}
                            </td>

                            <td
                                style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.cost}}
                            </td>
                            <td
                                style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.createdDate | date: 'EEE MMM dd yyyy HH:mm:ss'}}
                            </td>

                            <td
                                style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.status}}
                            </td>
                            <td
                                style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.nextMaintenanceDate | date: 'EEE MMM dd yyyy HH:mm:ss'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </tr>
        </table>



    </div>
</div>




    </div>